(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["male-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }
  function init(scope) {
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;
    scope.querySelectorAll('.mh-reveal:not([data-mh-r])').forEach(function (el) { el.setAttribute('data-mh-r', '1'); if (io) io.observe(el); else el.classList.add('in'); });
    scope.querySelectorAll('.mh-vn__wave[data-bars]:not([data-mh-b])').forEach(function (w) {
      w.setAttribute('data-mh-b', '1');
      w.getAttribute('data-bars').split(',').forEach(function (h) { var b = document.createElement('span'); b.style.height = (parseInt(h, 10) || 10) + 'px'; w.appendChild(b); });
    });
    scope.querySelectorAll('.mh-vn:not([data-mh-v])').forEach(function (card) {
      card.setAttribute('data-mh-v', '1');
      var btn = card.querySelector('.mh-vn__btn'), icon = card.querySelector('.mh-vn__icon'), wave = card.querySelector('.mh-vn__wave'), time = card.querySelector('.mh-vn__time');
      var src = card.getAttribute('data-audio');
      if (!btn) return;
      var off = function () { icon.textContent = '▶'; icon.style.marginRight = '-2px'; btn.style.background = '#C7D2E4'; btn.style.cursor = 'default'; btn.setAttribute('aria-disabled', 'true'); };
      if (!src) { off(); return; }
      var audio = new Audio(src);
      var fmt = function (s) { return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0'); };
      var paint = function (r) { var b = wave.children; for (var i = 0; i < b.length; i++) b[i].style.background = (i / b.length) <= r ? '#2158B8' : '#B9C9E4'; };
      audio.addEventListener('timeupdate', function () { if (audio.duration) { paint(audio.currentTime / audio.duration); time.textContent = fmt(audio.currentTime); } });
      audio.addEventListener('ended', function () { icon.textContent = '▶'; icon.style.marginRight = '-2px'; paint(0); });
      audio.addEventListener('error', off);
      audio.addEventListener('loadedmetadata', function () { if (audio.duration) time.textContent = fmt(audio.duration); });
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        if (window.__mhAudio && window.__mhAudio !== audio) window.__mhAudio.pause();
        if (audio.paused) { icon.textContent = '❚❚'; icon.style.marginRight = '0'; window.__mhAudio = audio; audio.play().catch(off); pub('male_video_started', { tracking_version: '1', page_type: 'index', element_key: 'voice-review', action: 'audio_play' }); }
        else { audio.pause(); icon.textContent = '▶'; icon.style.marginRight = '-2px'; }
      });
    });
  }
  if (!window.__mhClick) {
    window.__mhClick = true;
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('.mh [data-male-el]');
      if (!el) return;
      var sec = el.closest('[data-male-section]');
      var a = el.getAttribute('data-male-action');
      pub(a === 'navigation_click' ? 'male_navigation_clicked' : 'male_cta_clicked', { tracking_version: '1', page_type: 'index', page_path: location.pathname, section_key: sec ? sec.getAttribute('data-male-section') : undefined, element_key: el.getAttribute('data-male-el'), action: a, link_path: el.pathname || undefined });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
